import { Header } from "@neonumy/neonumy-ui";
import { useAuth } from "config/auth/useAuth";
import useStore from "config/store";
import useCompanyPermissions from "hooks/Permissions/useCompanyPermissions";
import { matchPath, useLocation } from "react-router-dom";
import LogoHome from "resources/images/neo-dashboard-home.svg?react";
import Logo from "resources/images/neo-dashboard.svg?react";
import { isNewraiUser } from "utils/isNewraiUser";
import getDomainSuffix from "utils/getDomainSuffix";
import { useGetAndSaveCompanies } from "views/Base/hooks/useGetAndSaveCompanies";
import { useQueryCompanyAccountingFirm } from "views/Base/hooks/useQueryCompanyAccountingFirm";
import { HOME_ROUTES } from "views/Home/utils/homeRoutes";
import { ACCOUNT_ROUTES } from "views/Profile/utils/accountRoutes";
import { useMenuItems } from "./useMenuItems";

export function AppHeader() {
  const { logout } = useAuth();
  const location = useLocation();

  const userData = useStore(state => state.userData);
  const companySelected = useStore(state => state.companySelected);
  const accountingFirmSelected = useStore(state => state.accountingFirmSelected);
  const menuItems = useMenuItems();
  const { canViewCompaniesList, canNavigateWithCompany } = useCompanyPermissions();
  const { onSaveCompany } = useGetAndSaveCompanies();
  useQueryCompanyAccountingFirm();

  const displayCompanySelect =
    ["client"].includes(userData?.userCategory?.slug) && canViewCompaniesList;

  const isClientCompanyHome = !!matchPath(HOME_ROUTES.companyHome, location.pathname);
  const isArticlesRoute =
    !!matchPath(HOME_ROUTES.articles, location.pathname) ||
    !!matchPath(HOME_ROUTES.article, location.pathname);

  const partialUserData = {
    firstName: userData?.firstName ?? "",
    lastName: userData?.lastName ?? "",
    email: userData?.email ?? "",
    category: userData?.userCategory?.slug ?? "",
    isNewraiUser: isNewraiUser(userData),
  };

  const appsUrlParams = canNavigateWithCompany
    ? {
        companyId: companySelected?.id,
        accountingFirmId: accountingFirmSelected?.id,
      }
    : {};

  const domainSuffix = getDomainSuffix();

  const urlIsNewRai = domainSuffix.includes("newrai.fr") || domainSuffix.includes("neonumy.dev");
  const hasNeofeedAccess =
    (userData?.isSuperuser || userData?.permissions.includes("neofeed.can-access")) && urlIsNewRai;

  const isHome = location.pathname === "/";
  const neofeedReplacesNotifications = isHome && hasNeofeedAccess;
  const displayNotifications = !neofeedReplacesNotifications;

  return (
    <Header
      appLogo={
        isHome ? <LogoHome style={{ height: "30px" }} /> : <Logo style={{ height: "30px" }} />
      }
      appName="Dashboard"
      userData={partialUserData}
      companySelected={companySelected}
      accountingFirmSelected={accountingFirmSelected}
      appsUrlParams={appsUrlParams}
      showNeoAcademy={true}
      userAvatar={{
        profileHref: ACCOUNT_ROUTES.profile,
        handleLogout: logout,
      }}
      menuItems={menuItems}
      appsDrawerPersistent={isHome || isClientCompanyHome || isArticlesRoute}
      showNotifications={displayNotifications}
      {...(displayCompanySelect && {
        selectCompanyOptions: {
          isEditable: true,
          companyOnly: true,
          handleOnSelectCompany: onSaveCompany,
        },
      })}
    />
  );
}
